import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { router } from './app/router.js';
import { SessionProvider } from './session/SessionProvider.js';
import './styles/global.css';

// A deploy during an open session leaves the page pointing at chunks that no longer match.
// Vite reports it as a preload error; one reload picks up the current build. The flag stops a
// loop if the reload does not fix it.
const RELOAD_FLAG = 'titan.reloaded-after-preload-error';
window.addEventListener('vite:preloadError', (event) => {
  let already = false;
  try {
    already = sessionStorage.getItem(RELOAD_FLAG) === '1';
    if (!already) sessionStorage.setItem(RELOAD_FLAG, '1');
  } catch {
    // Storage unavailable: fall through to the error screen.
  }
  if (already) return;
  event.preventDefault();
  window.location.reload();
});
try {
  // Clear the flag once a build has loaded normally.
  window.addEventListener('load', () => sessionStorage.removeItem(RELOAD_FLAG));
} catch {
  // ignore
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SessionProvider>
      <RouterProvider router={router} />
    </SessionProvider>
  </StrictMode>,
);
